import { useEffect } from 'react';

const SITE = 'https://cybernate.ai';
const DEFAULT_IMAGE = `${SITE}/og-image.jpg`;
const TWITTER_HANDLE = '@cybernate_ai';

function setMeta(selector, attr, content) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, key, val] = selector.match(/\[(\w[\w:]+)="(.+?)"\]/);
    el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function useSEO({ title, description, path = '/', image = DEFAULT_IMAGE }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — Cybernate`
      : 'Cybernate — General intelligence, built for Africa';
    const url = `${SITE}${path}`;

    document.title = fullTitle;

    setMeta('meta[name="description"]', 'content', description);
    setLink('canonical', url);

    setMeta('meta[property="og:title"]', 'content', fullTitle);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[property="og:site_name"]', 'content', 'Cybernate');

    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:site"]', 'content', TWITTER_HANDLE);
    setMeta('meta[name="twitter:title"]', 'content', fullTitle);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);

    setMeta('meta[name="geo.region"]', 'content', 'NG');
    setMeta('meta[name="geo.placename"]', 'content', 'Lagos, Nigeria');
    setMeta('meta[name="ICBM"]', 'content', '6.5244, 3.3792');
  }, [title, description, path, image]);
}
